import * as tslib_1 from "tslib";
import { EquipamentoRdService } from 'src/app/services/equipamento-rd.service';
import { RdService } from 'src/app/services/rd.service';
import { OnInit, AfterContentInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ModeloRdService } from 'src/app/services/modelo-rd.service';
import { DatePipe } from '@angular/common';
import { SCAMP_API_RPT } from 'src/environments/environment';
//202003221205
export class EmissaoRdComponent {
    constructor(modeloRDService, toastr, modalService, usuarioService, formBuilder, rdService, equipamentoRDService, datePipe) {
        this.modeloRDService = modeloRDService;
        this.toastr = toastr;
        this.modalService = modalService;
        this.usuarioService = usuarioService;
        this.formBuilder = formBuilder;
        this.rdService = rdService;
        this.equipamentoRDService = equipamentoRDService;
        this.datePipe = datePipe;
        this.cadastrados = [];
        this.modelosRD = [];
        this.rDEquipamentos = [];
        this.fieldsDetEquipamento = ["manhaNormal", "tardeNormal", "manhaEspecial", "tardeEspecial", "diaria", "horas"];
        this.form = null;
        this.id = 0; // representa o id do modelo. Se 0 novo cadastro, Se > 0 editando
        this.isProcessing = false;
        this.isEditing = false;
        this.imprimindoRD = false;
        this.imprimindoRDId = 0;
        this.validaDataInicio = '';
        this.validaDataTermino = '';
        this.rds = [];
        this.validaSituacaoClimatica = '';
        this.validaDataModeloRDUnico = '';
        this.validaDataRDExistente = '';
        this.validaRDIdExistente = '';
        //rDIdExistente
        this.rdExistente = null;
        this.isUniqueDataRdModeloIdAsync = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            const data = this.form.value;
            this.validaDataModeloRDUnico = '';
            if (data.rDData && data.rDModeloId) {
                // Verifica se Data + Modelo já existem
                const response = yield this.rdService.isUniqueDataRdModeloId(data.rDData, data.rDModeloId, data.id).toPromise();
                if (response == false) {
                    this.validaDataModeloRDUnico = "Este Modelo RD para esta data já está em uso";
                }
                return response;
            }
            else {
                return false;
            }
        });
        this.validForm = () => {
            let valid = true;
            this.validaSituacaoClimatica = '';
            if (!this.form.get('condicaoClima').value) {
                this.validaSituacaoClimatica = 'Selecione uma situação climática';
                valid = false;
            }
            return valid;
        };
    }
    ngAfterContentInit() {
        this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('emitir-rd');
    }
    ngOnInit() {
        //this.getAll(); // carrega lista de já cadastrados
        this.getAllModelosRD();
        this.getAllEquipamentosRDWithDetPromise(0);
        this.resetForm(); // instancia o formulário utilizado (formGroup)
    }
    getNextRdNumeroSeq() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (yield this.isUniqueDataRdModeloIdAsync()) {
                const data = this.form.value;
                this.validaDataModeloRDUnico = '';
                if (data.rDData && data.rDModeloId) {
                    /*    this.rdService.getNextRdNumeroSeq(data.rDData).subscribe((response) => {
                         this.form.get('rDNumeroSeq').setValue(Number(response));
                       }); */
                    this.rdService.getNextRdNumeroSeqPromise(data.rDData)
                        .then(response => response.json())
                        .then(json => this.form.get('rDNumeroSeq').setValue(Number(json)));
                }
            }
        });
    }
    getAllModelosRD() {
        /* this.modeloRDService.getAll().subscribe((response: any) => {
          this.modelosRD = response;
        }); */
        this.modeloRDService.getAllPromise()
            .then(response => response.json())
            .then(json => this.modelosRD = json);
    }
    getAllEquipamentosRDWithDet(rdId, reuso = false) {
        this.isProcessing = true;
        this.rDEquipamentos = [];
        this.equipamentoRDService.getAllWithDet(rdId).subscribe((response) => {
            this.rDEquipamentos = response;
            this.rDEquipamentos.forEach(x => {
                x.rdDetsEquipamento[0].hasAnyData = false;
            });
            if (rdId > 0) {
                this.rDEquipamentos.forEach(rd => {
                    this.fieldsDetEquipamento.forEach(f => rd.rdDetsEquipamento[0].hasAnyData =
                        (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0][f] !== null));
                    rd.rdDetsEquipamento[0].hasAnyData =
                        (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0].observacao !== null);
                });
            }
            if (reuso) {
                this.rDEquipamentos.forEach(rd => {
                    rd.rdDetsEquipamento.forEach(det => {
                        det.rdId = 0;
                        det.id = 0;
                    });
                });
            }
            this.isProcessing = false;
        }, (error) => {
            this.isProcessing = false;
            this.showError(error);
        });
    }
    getAllEquipamentosRDWithDetPromise(rdId, reuso = false) {
        this.isProcessing = true;
        this.rDEquipamentos = [];
        this.equipamentoRDService.getAllWithDetPromise(rdId)
            .then(response => response.json())
            .then(json => {
            this.rDEquipamentos = json;
            this.rDEquipamentos.forEach(x => {
                x.rdDetsEquipamento[0].hasAnyData = false;
            });
            if (rdId > 0) {
                this.rDEquipamentos.forEach(rd => {
                    this.fieldsDetEquipamento.forEach(f => rd.rdDetsEquipamento[0].hasAnyData =
                        (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0][f] !== null));
                    rd.rdDetsEquipamento[0].hasAnyData =
                        (rd.rdDetsEquipamento[0].hasAnyData || rd.rdDetsEquipamento[0].observacao !== null);
                });
            }
            if (reuso) {
                this.rDEquipamentos.forEach(rd => {
                    rd.rdDetsEquipamento.forEach(det => {
                        det.rdId = 0;
                        det.id = 0;
                    });
                });
            }
            this.isProcessing = false;
        })
            .catch((error) => {
            this.isProcessing = false;
            this.showError(error);
        });
    }
    changeSituacaoClimatica(situacao) {
        this.form.get('condicaoClima').setValue(situacao);
        this.validaSituacaoClimatica = '';
    }
    /*  public getAll(): void {
      
     } */
    resetForm() {
        this.form = this.formBuilder.group({
            id: [0],
            rDNumeroSeq: [null],
            condicaoClima: [null],
            rDData: [this.datePipe.transform(new Date(), 'yyyy-MM-dd'), [Validators.required]],
            rDModeloId: [null, [Validators.required]],
            obsContratada: [null],
            obsFiscalizacao: [null],
            rDDetEquipamentos: [[]],
        });
        this.isEditing = false;
    }
    reset() {
        this.isProcessing = false;
        this.isEditing = false;
        this.validaSituacaoClimatica = '';
        this.validaDataInicio = '';
        this.validaDataTermino = '';
        this.validaDataRDExistente = '';
        this.validaRDIdExistente = '';
        this.validaDataModeloRDUnico = '';
        this.resetForm();
        this.getAllEquipamentosRDWithDet(0);
    }
    submit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.validForm() && (yield this.isUniqueDataRdModeloIdAsync())) {
                let detEquipamentos = [];
                this.rDEquipamentos.forEach(x => {
                    if (x.rdDetsEquipamento[0].id > 0 || x.rdDetsEquipamento[0].hasAnyData) {
                        detEquipamentos.push(x.rdDetsEquipamento[0]);
                    }
                });
                this.form.get('rDDetEquipamentos').setValue(detEquipamentos);
                this.rdService.add(this.form.value).subscribe((response) => {
                    if (response.success == true) {
                        this.toastr.success(response.message);
                    }
                    else {
                        this.toastr.warning(response.message);
                    }
                    this.reset();
                    //this.getAll();
                }, (error) => {
                    this.showError(error);
                });
            }
        });
    }
    changeRDDetEquipamento(equipamentoId, field, value) {
        const rdEquipamento = this.rDEquipamentos.find(x => x.id == equipamentoId);
        if (rdEquipamento) {
            rdEquipamento.rdDetsEquipamento[0][field] = value ? value : null;
            if (rdEquipamento.rdDetsEquipamento[0][field] != null) {
                rdEquipamento.rdDetsEquipamento[0].hasAnyData = true;
            }
            else {
                rdEquipamento.rdDetsEquipamento[0].hasAnyData = false;
                this.fieldsDetEquipamento.forEach(f => rdEquipamento.rdDetsEquipamento[0].hasAnyData =
                    (rdEquipamento.rdDetsEquipamento[0].hasAnyData || rdEquipamento.rdDetsEquipamento[0][f] !== null));
                rdEquipamento.rdDetsEquipamento[0].hasAnyData =
                    (rdEquipamento.rdDetsEquipamento[0].hasAnyData || rdEquipamento.rdDetsEquipamento[0].observacao !== null);
            }
        }
    }
    showError(error) {
        this.form.get('nome').setErrors({ hasError: true });
        if (error.error.errors) {
            this.toastr.error(error.error.errors[0].message);
        }
        else {
            this.toastr.error('Ocorreu um erro no servidor');
        }
        this.isProcessing = false;
    }
    showModalPesquisarRD(modal) {
        this.rds = [];
        this.modalService.open(modal, { windowClass: 'xlModal', backdrop: 'static' });
    }
    showModalReuseRD(modal) {
        this.rdExistente = null;
        this.modalService.open(modal, { windowClass: 'lgModal', backdrop: 'static' });
    }
    search() {
        this.validaDataInicio = '';
        this.validaDataTermino = '';
        let inputDataInicio = document.getElementById('inputDataInicio').value;
        let inputDataTermino = document.getElementById('inputDataTermino').value;
        if (inputDataInicio == '') {
            this.validaDataInicio = 'Informe uma data válida';
        }
        if (inputDataTermino == '') {
            this.validaDataTermino = 'Informe uma data válida';
        }
        if (inputDataInicio == '' || inputDataTermino == '') {
            return;
        }
        let dataIntervaloInicio = new Date(new Date(inputDataInicio).getTime() + 3 * 60 * 60 * 1000); // correção GMT
        let dataIntervaloTermino = new Date(new Date(inputDataTermino).getTime() + 3 * 60 * 60 * 1000); // correção GMT
        if (dataIntervaloInicio.getTime() > dataIntervaloTermino.getTime()) {
            const dataTemp = inputDataInicio;
            document.getElementById('inputDataInicio').value = inputDataTermino;
            document.getElementById('inputDataTermino').value = inputDataInicio;
            inputDataInicio = inputDataTermino;
            inputDataTermino = dataTemp;
        }
        this.rds = [];
        /*     this.rdService.getByIntervalAsync(inputDataInicio, inputDataTermino).subscribe(
              (response) => {
                this.rds = response;
                if (this.rds.length == 0) {
                  this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados")
                }
              }
            ) */
        this.rdService.getByIntervalPromise(inputDataInicio, inputDataTermino)
            .then(response => response.json())
            .then(json => {
            this.rds = json;
            if (this.rds.length == 0) {
                this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados");
            }
        })
            .catch(this.showError);
    }
    searchRDExistente() {
        this.validaDataRDExistente = '';
        this.validaRDIdExistente = '';
        let inputData = document.getElementById('inputDataRDExistente').value;
        let rdModeloIdExistente = document.getElementById('rdModeloIdExistente').value;
        if (inputData == '') {
            this.validaDataRDExistente = 'Informe uma data válida';
        }
        if (rdModeloIdExistente == '') {
            this.validaRDIdExistente = 'Selecione um modelo RD';
        }
        if (inputData == '' || !rdModeloIdExistente) {
            return;
        }
        this.rdExistente = null;
        this.rdService.getByDataAndModeloRD(inputData, rdModeloIdExistente).subscribe((response) => {
            this.rdExistente = response;
            if (!this.rdExistente) {
                this.toastr.warning("A pesquisa não retornou resulados com os parâmetros informados");
            }
        });
    }
    getById(rdId, reuso = false) {
        this.reset();
        this.isProcessing = true;
        this.rdService.getById(rdId).subscribe((response) => {
            this.form.patchValue({
                id: response.id,
                rDNumeroSeq: response.rdNumeroSeq,
                condicaoClima: response.condicaoClima,
                rDData: response.rdData.split('T')[0],
                rDModeloId: response.rdModeloId,
                obsContratada: response.obsContratada,
                obsFiscalizacao: response.obsFiscalizacao,
                rDDetEquipamentos: [],
            });
            this.getAllEquipamentosRDWithDet(rdId, reuso);
            this.isEditing = true;
            this.isProcessing = false;
            this.modalService.dismissAll();
            if (reuso) {
                this.form.get('id').setValue(0);
                this.isEditing = false;
            }
        }, (error) => {
            this.showError(error);
        });
    }
    reuseRD() {
        if (this.rdExistente != null) {
            //this.reset();
            this.getById(this.rdExistente.id, true);
        }
    }
    imprimirRD(rdId) {
        if (rdId == 0) {
            return;
        }
        this.imprimindoRD = true;
        this.imprimindoRDId = rdId;
        this.rdService.imprimirRD(rdId).subscribe((response) => {
            if (response.success === true) {
                if (response.nenhumResultado === false) {
                    window.open(`${SCAMP_API_RPT.root}${response.pathRpt}`, '_blank', 'width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no');
                }
                else {
                    this.toastr.warning(response.msgErro);
                }
            }
            else {
                this.toastr.error(response.msgErro);
            }
            this.imprimindoRD = false;
            this.imprimindoRDId = 0;
        }, (err) => {
            this.toastr.error('Não foi possível se conectar ao servidor de relatórios', 'Erro de Conexão');
            this.imprimindoRD = false;
            this.imprimindoRDId = 0;
        });
    }
}
